
import { computed, defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { decimal, required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: true,
        },
        ftlType: {
            type: Number,
            default: null,
        },
        rateType: {
            type: Number,
            default: null,
        },
    },
    emits: ['cancel', 'submitted'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            paid_price: null as number | null,
        })

        const state_form$ = useVuelidate({ paid_price: { required, decimal } }, state)

        const emitCancel = () => {
            emit('cancel')
        }

        const emitSubmitted = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submitted', Number(state.paid_price))
        }

        const getPlaceholder = computed(() => {
            let placeholder = 'Выставление клиенту'

            if (props.ftlType === 2) {
                if (props.rateType === 1) placeholder += ' (за час)'
                else placeholder += ' (за рейс)'
            }

            return placeholder
        })

        return {
            state,
            state_form$,
            emitCancel,
            emitSubmitted,
            getPlaceholder,
        }
    },
})
